import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["marks", "defaultValue", "disabled", "onChange", "value", "onChangeCommitted", "step"];
import Slider from "@mui/material/Slider";
import { gray } from "../../theme/palette";
var marks = [{
        value: 0,
        label: "E"
    }, {
        value: 25,
        label: "I"
    }, {
        value: 50,
        label: "1/2"
    }, {
        value: 75,
        label: "I"
    }, {
        value: 100,
        label: "F"
    }];
export var MuiSlider = function (props) {
    var marks = props.marks, _a = props.defaultValue, defaultValue = _a === void 0 ? 0 : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, onChange = props.onChange, value = props.value, onChangeCommitted = props.onChangeCommitted, step = props.step, others = _objectWithoutProperties(props, _excluded);
    var valuetext = function (value) {
        return "".concat(value, " %");
    };
    return /*#__PURE__*/ React.createElement(Slider, _extends({
        valueLabelDisplay: "on",
        sx: {
            width: "100%",
            "& .MuiSlider-rail": {
                backgroundColor: gray
            },
            "& .MuiSlider-thumb": {
                height: 20,
                width: 20,
                backgroundColor: "#fff",
                border: "2px solid currentColor",
                "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
                    boxShadow: "inherit"
                },
                "&::before": {
                    display: "none"
                }
            },
            "& .MuiSlider-mark": {
                border: "1px solid gray",
                height: 5,
                width: 5,
                backgroundColor: "#fff",
                borderRadius: '50%'
            },
            "& .MuiSlider-markActive": {
                backgroundColor: "currentColor",
                opacity: 1,
                height: 8,
                width: 8,
                border: "1px solid currentColor",
                borderRadius: '50%'
            }
        },
        defaultValue: defaultValue,
        getAriaValueText: valuetext,
        valueLabelFormat: valuetext,
        step: step,
        marks: marks,
        disabled: disabled,
        onChange: onChange,
        value: value,
        onChangeCommitted: onChangeCommitted
        // onDragStop={onDragStop}
    }, others));
};
